import styles from './SubmenuItem.module.css';
import { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { CustomMenuItem } from 'models/digitalMap';

export const SubmenuItem = ({ item }: { item: CustomMenuItem }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      className={clsx(styles['desktop-item'], {
        [styles.open]: isOpen,
      })}
      onClick={() => setIsOpen(!isOpen)}
      ref={dropdownRef}
    >
      <span className={clsx(styles['label'], { [styles.active]: isOpen })}>{item.label}</span>
      {isOpen && (
        <div className={styles.dropdown}>
          {item.sub_menu_items.map((subMenuItem) => (
            <div
              key={subMenuItem.label}
              className={styles.option}
              onClick={() => window.open(subMenuItem.url, '_blank')}
            >
              {subMenuItem.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
